"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TypedRecord = _interopRequireDefault(require("./TypedRecord"));

var _default = (0, _TypedRecord.default)({
  startDate: _propTypes.default.number
}, 'ResolverLoading');

exports.default = _default;
module.exports = exports.default;